import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    // iconFont: 'mdiSvg'
});

//todo iconFont 사용되는건지 확인 후 필요없으면 삭제